import { put, takeLatest, call } from 'redux-saga/effects';

import {
  getAuntiesSuccess,
} from '../actionCreators/auntiesActions';
import { GET_AUNTIES_REQUEST } from '../constants/actionTypes';
import { AuntiesApi } from '../api';
import errorHandler from '../utils/requestErrorHandler';

function* getAunties(action) {
  try { 
    const data = yield call(AuntiesApi.getAunties, action.payload);

    yield put(getAuntiesSuccess(data));
  } catch (error) {
    yield errorHandler(error);
  }
}

export default function* watchChallenge() {
  yield takeLatest(GET_AUNTIES_REQUEST, getAunties);
}
